import React, {useEffect, useState, useRef} from 'react';
import searchIcon from '../../../imgs/search.svg';
import searchWhite from '../../../imgs/searchWhite.svg';
import HomeCard from './homeCard';
import HomeSidebar from './../homeSidebar/homeSidebar';
import {
  GET_BOUNTIES,
  COUNT_TOTAL_BOUNTIES_PRICE,
} from './../../../graphql/query/bounties';
import {gql, useLazyQuery, useQuery} from '@apollo/client';
import {removeDuplicates} from './../../../utils/helpers/reusableFuntions';
import lodash from 'lodash';
import {withSocket} from './../../../utils/withSocket';
import { Spin } from 'antd';

const Home = ({socket}) => {
  const [showSearch, setShowSearch] = useState(false);
  const [start, setStart] = useState(0);
  const [limit] = useState(10);
  const [query, setQuery] = useState('');
  const [bounties, setBounties] = useState([]);
  const [rendering, setRendering] = useState(true);
  const [price, SetPrice] = useState('');
  const [hasMore, setHasMore] = useState(true);
  const [isNextRequest, setIsNextRequest] = useState(true);
  const [page, setPage] = useState(1);
  const loader = useRef(null);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
  }, []);

  useEffect(() => {
    // here we simulate adding new posts to List
    if (isNextRequest) {
      setStart(start + 10);
      setIsNextRequest(false);
      getBounties({variables: {query: query, start: start + 10, limit}});
    }
    // const newList = postList.list.concat([1,1,1,1]);
    // setPostList({
    //     list: newList
    // })
  }, [page]);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage((page) => page + 1);
    }
  };

  const {} = useQuery(gql(COUNT_TOTAL_BOUNTIES_PRICE), {
    variables: {
      status: 'active',
    },
    onCompleted: (res) => {
      if (res?.countTotalBountyPrice?.amount > 0) {
        SetPrice(
          res?.countTotalBountyPrice?.amount
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        );
      }
    },
  });

  const [getBounties, {data: bountiesList}] =
    useLazyQuery(gql(GET_BOUNTIES), {
      fetchPolicy: 'cache-and-network',
    });
  const debounce = lodash.debounce((event) => handleSearchQuery(event), 1000);

  const handleSearchQuery = (value) => {
    setStart(0);
    getBounties({variables: {query: query, start: 0, limit}});
  };

  useEffect(() => {
    if (!bounties.length && rendering) {
      setRendering(false);
      getBounties({variables: {query: query, start, limit}});
    }
  }, []);

  useEffect(() => {
    debounce(query);
  }, [query]);

  useEffect(() => {
    if (bountiesList && bountiesList.searchBounties) {
      setIsNextRequest(true);
      if (query) {
        setBounties(bountiesList.searchBounties);
      } else {
        if (bountiesList.searchBounties.length) {
          if (bountiesList.searchBounties.length < 10) setHasMore(false);
          let mergeBounties = [...bounties, ...bountiesList.searchBounties];
          const result = removeDuplicates(mergeBounties);
          setBounties(
            result.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at),
            ),
          );
        } else {
          setHasMore(false);
        }
      }
    }
  }, [bountiesList]);

  const fetchMoreData = () => {
    if (isNextRequest) {
      setStart(start + 10);
      setIsNextRequest(false);
      getBounties({variables: {query: query, start: start + 10, limit}});
    }
  };

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content">
        <div className="home-search">
          {price ?
            <h2 className="heading">
            ${price}
            <span> Active bounties</span>
          </h2>
          : 
          <h2 className="heading">
          <span> Active bounties</span>
        </h2>
          }
          <button
            className="search-btn"
            onClick={() => setShowSearch(!showSearch)}>
            <img src={searchIcon} alt="logo" />
          </button>
          {showSearch && (
            <div className="search-bar">
              <img src={searchWhite} alt="logo" />
              <input
                type="search"
                value={query}
                onChange={(event) => {
                  setQuery(event.target.value);
                }}
                placeholder="Search name, company"
              />
            </div>
          )}
        </div>
        <div className="home-info">
          <h2 className="small-heading">Get paid to make warm intros.</h2>
          <p>Make intro if you have the connection.</p>
        </div>
        <div className="home-content-feeds">
          {bounties && bounties.length ? (
            bounties.map((bounty, index) => {
              return (
                <>
                  {bounty.status === 'active' && (
                    <HomeCard key={index} bounty={bounty} />
                  )}
                </>
              );
            })
          ) : (
            <></>
          )}
          {hasMore && (
            <div className="loading" ref={loader}>
              <Spin spinning={loader} className="spin-loading" />
            </div>
          )}
        </div>

        {/* </div> */}
      </div>
    </div>
  );
};

export default withSocket(Home);
